import alt from 'components/Dispatcher';
import ProductSource from 'sources/ProductSource';
import ProductActions from 'actions/ProductActions';

export class ProductStore{
  constructor() {
    this.state = {
      productId: null,
      slides: [],
      products: [],
      product: {},
      teams: [],
      comments: [],
      count: 0,
      params: {},
      articleParams: {},
      feature_id: null,
      first: 0,
      maxCount: 20,
      type: '',
      loading: false,
      hasMore: true,
      offset: 0,
      planOffset: 0,
      tipsOffset: 0,
      commentOffset: 0
    };

    this.registerAsync(ProductSource);
    this.bindListeners({
      handleFetchProducts: ProductActions.FETCH_PRODUCTS,
      handleFetchSlides: ProductActions.FETCH_SLIDES,
      handleUpdateProducts: ProductActions.UPDATE_PRODUCTS,
      handleUpdateSlides: ProductActions.UPDATE_SLIDES,
      handleFetchProduct: ProductActions.FETCH_PRODUCT,
      handleFetchTeams: ProductActions.FETCH_TEAMS,
      handleFetchComments: ProductActions.FETCH_COMMENTS,
      handleUpdateTeams: ProductActions.UPDATE_TEAMS,
      handleUpdateComments: ProductActions.UPDATE_COMMENTS,
      handleUpdateProduct: ProductActions.UPDATE_PRODUCT,
      handleFetchLoading: ProductActions.FETCH_LOADING,
      handleFetchSuccess: ProductActions.FETCH_SUCCESS,
      handleFetchError: ProductActions.FETCH_ERROR,
      handleRefreshProduct: ProductActions.REFRESH_PRODUCT,
      handleUpdateProductOffset: ProductActions.UPDATE_PRODUCT_OFFSET,
      handleUpdateProductPlanOffset: ProductActions.UPDATE_PRODUCT_PLAN_OFFSET,
      handleUpdateProductCommentOffset: ProductActions.UPDATE_PRODUCT_COMMENT_OFFSET,
      handleUpdateProductTipsOffset: ProductActions.UPDATE_PRODUCT_TIPS_OFFSET,
      handleClearProduct: ProductActions.CLEAR_PRODUCT,
      handleSetLoading: ProductActions.SET_LOADING,
      handleUpdateAllProducts: ProductActions.UPDATE_ALL_PRODUCTS,
      handleUpdateFeatureId: ProductActions.UPDATE_FEATURE_ID,
      handleUpdateFetchType: ProductActions.UPDATE_FETCH_TYPE,
      handleClearProducts: ProductActions.CLEAR_PRODUCTS,
      handleClearType: ProductActions.CLEAR_TYPE
    });
  }
  handleClearProducts(){
    this.setState({products:[]})
  }
  handleClearType(){
    this.setState({type:''})
  }
  handleUpdateFetchType(type){
    this.setState({type:type})
  }
  handleSetLoading(loading) {
    this.setState({loading: loading});
  }
  handleFetchProducts(params) {
    let first = this.state.products.length ? this.state.products.length + 1 : 0;
    this.setState({first: first, loading: true});
    this.getInstance().getRemoteProducts();
  }
  handleFetchSlides(){
    this.getInstance().getRemoteSlides();
  }
  handleUpdateProducts(products) {
    let more = products.length === this.state.maxCount;
    let list = this.state.products.concat(products);
    this.setState({products: list, loading: false, hasMore: more});
  }
  handleUpdateAllProducts(products){
    this.setState({products: products});
  }
  handleUpdateProductOffset(offset){
    this.setState({offset:offset});
  }
  handleUpdateProductPlanOffset(offset){
    this.setState({planOffset:offset});
  }
  handleUpdateProductCommentOffset(offset){
    this.setState({commentOffset:offset});
  }
  handleUpdateProductTipsOffset(offset){
    this.setState({tipsOffset:offset});
  }
  handleClearProduct() {
    this.setState({product:{}});
  }
  handleUpdateSlides(data) {
    this.setState(data);
  }
  handleUpdateFeatureId(feature_id) {
    this.setState({feature_id: feature_id, first: 0, products: []});
    this.getInstance().getRemoteProducts();
  }
  handleFetchProduct(id) {
    this.setState({productId: id});
    this.getInstance().getRemoteProduct();
  }
  handleFetchTeams(id) {
    this.setState({productId: id});
    this.getInstance().getRemoteTeams();
  }
  handleFetchComments(id) {
    this.setState({productId: id});
    this.getInstance().getRemoteComments();
  }
  handleUpdateTeams(data){
    this.setState(data);
  }
  handleUpdateComments(data){
    this.setState(data);
  }
  handleRefreshProduct() {
    this.getInstance().getRemoteProducts();
    this.getInstance().getRemoteProduct();
  }
  handleUpdateProduct(product) {
    this.setState({product});
  }
  handleFetchLoading() {
    this.setState({loading: true});
  }
  handleFetchSuccess() {
    this.setState({loading: false});
  }
  handleFetchError(error) {
    this.setState({error});
  }
}

export default alt.createStore(ProductStore, 'ProductStore');



// WEBPACK FOOTER //
// ./src/stores/ProductStore.js